import {composeReducers} from 'common/util/composeReducers';
import descriptorsReducer from './descriptors';
import documentTypesReducer from './documentTypes';
import institutionsReducer from './institutions';
import part11Reducers from 'part11/reducers';

const institutionalAdminReducer = composeReducers(
    descriptorsReducer,
    documentTypesReducer,
    institutionsReducer,
    part11Reducers
);
export default institutionalAdminReducer;

